// This file contains all the Supported Widgets for AnalyticsV2
import { IAnalyticsUsageDataHook } from "@tdp/modules/apps";

import { AnalyticsV2Keys } from "./EAnalytics";
import { Metric, GroupName, Group } from "./IAnalyticsFilters";
/**
 * Key : Key of the Widget to be fetched
 * dependencyFilters : Filters on which the widget depends, if any of the filter is updated, widget needs to be refreshed
 * groups : Groups required by the API to fetch the data
 * metric : Metrics required by the API to fetch the data
 */

export const usageByTimePeriod: IAnalyticsUsageDataHook = {
  key: AnalyticsV2Keys.UsageByTimePeriod,
  groupName: GroupName.UsageData,
  dependencyFilters: {
    entityType: true,
    area: true,
    platform: true,
    os: true,
  },
  groups: [],
  metric: [
    Metric.Active,
  ]
}

export const usageByRetentionIntensity: IAnalyticsUsageDataHook = {
  key: AnalyticsV2Keys.UsageByRetentionIntensity,
  groupName: GroupName.UsageData,
  dependencyFilters: {
    entityType: true,
    area: true,
    platform: true,
    os: true,
  },
  groups: [],
  metric: [
    Metric.New,
    Metric.Returning,
    Metric.Resurrected,
    Metric.Lapsed,
    Metric.Median,
    Metric.Percentage5Days,
    Metric.Ratio
  ]
}

export const usageByRegion: IAnalyticsUsageDataHook = {
  key: AnalyticsV2Keys.UsageByRegion,
  groupName: GroupName.Area,
  dependencyFilters: {
    entityType: true,
    area: true,
    platform: true,
    os: true,
  },
  groups: [
    Group.Region,
  ],
  metric: [
    Metric.Active,
  ]
}

export const usageByHost: IAnalyticsUsageDataHook = {
  key: AnalyticsV2Keys.UsageByHost,
  groupName: GroupName.Host,
  dependencyFilters: {
    entityType: true,
    area: true,
    platform: true,
    os: true,
  },
  groups: [
    Group.Host,
  ],
  metric: [
    Metric.Active,
  ]
}

export const usageByOS: IAnalyticsUsageDataHook = {
  key: AnalyticsV2Keys.UsageByOS,
  groupName: GroupName.OS,
  dependencyFilters: {
    entityType: true,
    area: true,
    platform: true,
    os: true,
  },
  groups: [
    Group.OS,
  ],
  metric: [
    Metric.Active,
  ]
}

export const usageByPlatform: IAnalyticsUsageDataHook = {
  key: AnalyticsV2Keys.UsageByPlatform,
  groupName: GroupName.Platform,
  dependencyFilters: {
    entityType: true,
    area: true,
    platform: true,
    os: true,
  },
  groups: [
    Group.Platform,
  ],
  metric: [
    Metric.Active,
  ]
}

export const usageByHostCapability: IAnalyticsUsageDataHook = {
  key: AnalyticsV2Keys.UsageByCapability,
  groupName: GroupName.HostCapability,
  dependencyFilters: {
    entityType: true,
    platform: true,
    os: true,
    area: true,
    host: true
  },
  groups: [
    Group.Capability,
    Group.Host
  ],
  metric: [
    Metric.Active,
  ]
}

export const AppAnalyticsRegionDetailsRoute = `/apps/:appId/analytics/region`;

